"use strict";
'use es6';

var _requestKeys = require("./requestKeys");

var _utils = require("./utils");

var _requests = require("./requests");

(function () {
  if ((0, _utils.isEditorUrl)()) {
    (0, _requests.fetchLeadFlowById)((0, _utils.getIdFromCurrentUrl)());
    var state = window.earlyRequester.getRequestStateByName((0, _requestKeys.getFetchKey)((0, _utils.getIdFromCurrentUrl)()));
    state.whenFinished(function (_ref) {
      var id = _ref.id;
      return (0, _requests.fetchLeadFlowDraftById)(id);
    });
  }
})();